<template>
	<div class="full">
		<el-tabs class="full flex" style="flex-direction: column;" v-model="activeName" type="card">
			<el-tab-pane label="操作日志" name="log">
				<div class="pane_container">
					<log :row="row"  :key="'log_'+key" />
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<style scoped>
	.pane_container {
		position: relative;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 0px;
		overflow-y: auto;
		overflow-x: hidden;
		box-sizing: border-box;
	}
</style>
<script>
	import log from './log.vue';
	export default {
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				activeName: 'log',
				key: Math.random()
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			onSubmit() {
				console.log('submit!');
			},
			inittab() {
				this.key = Math.random()
			}
		},
		components: {
			log,
		}
	}
</script>
